import { render, staticRenderFns } from "./comparacionAnyo.vue?vue&type=template&id=15778683&scoped=true&"
import script from "./comparacionAnyo.vue?vue&type=script&lang=js&"
export * from "./comparacionAnyo.vue?vue&type=script&lang=js&"
import style0 from "./comparacionAnyo.vue?vue&type=style&index=0&id=15778683&prod&lang=scss&scoped=true&"
import style1 from "./comparacionAnyo.vue?vue&type=style&index=1&id=15778683&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15778683",
  null
  
)

export default component.exports